export enum HTTP_STATUS_CODES {
  SUCCESS = "success",
  USER_NOT_FOUND = "user_not_found"
}
